import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "m-4 mx-6 flex justify-center items-start flex-col" }
const _hoisted_2 = { class: "label-text" }
const _hoisted_3 = { class: "flex justify-start items-center flex-wrap" }
const _hoisted_4 = { class: "flex justify-start items-center gap-1 flex-wrap" }
const _hoisted_5 = { key: 1 }

import { computed } from "vue";
import { colord } from "colord";
import { LedRule, Repeat, Transition, RGB8 } from "@/keyboard";
import { keysDescription } from "@/keyboard/keys_utils";
import SettingsOption from "@/components/utils/SettingsOption.vue";
import ConditionView from "@/components/leds/ConditionView.vue";
import { Icon } from "@iconify/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LedRuleView',
  props: {
    rule: {}
  },
  setup(__props: any) {

const props = __props;

const keys = computed(() =>
  props.rule.keys == undefined ? null : props.rule.keys
);
// TODO: add warning about no keys selected (like in keyboard config, see warnings.ts)
const keysText = computed(() => keysDescription(keys.value));

const REPEAT_ICON: Record<Repeat, string> = {
  Once: "mdi:arrow-right",
  Wrap: "mdi:arrow-u-left-bottom",
  Reflect: "mdi:arrow-left-right",
};

const fromRgb8 = (c: RGB8) => ({ r: c[0], g: c[1], b: c[2] });
const hexColor = (t: Transition) => colord(fromRgb8(t.color)).toHex();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SettingsOption, {
      label: "Keys",
      tooltip: "Keys to which the rule applies"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(keysText.value), 1)
      ]),
      _: 1
    }),
    _createVNode(SettingsOption, {
      label: "Condition",
      tooltip: "Condition required for the rule to be active"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ConditionView, {
            condition: _ctx.rule.condition
          }, null, 8, ["condition"])
        ])
      ]),
      _: 1
    }),
    _createVNode(SettingsOption, {
      label: "Pattern",
      tooltip: "Color pattern used for a LED when the rule applies"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Icon), {
            icon: REPEAT_ICON[_ctx.rule.pattern.repeat],
            class: "mr-2"
          }, null, 8, ["icon"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rule.pattern.transitions, (trans, id) => {
            return (_openBlock(), _createElementBlock("div", {
              key: id,
              class: "h-6 flex justify-center items-center border rounded-xl border-base-content/20"
            }, [
              _createVNode(_unref(Icon), {
                class: "mx-0.5",
                icon: 
              trans.interpolation == 'Linear'
                ? 'mdi:arrow-top-right-thin'
                : 'mdi:stairs'
            
              }, null, 8, ["icon"]),
              (trans.duration === 0)
                ? (_openBlock(), _createBlock(_unref(Icon), {
                    key: 0,
                    icon: "mdi:infinity"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(trans.duration), 1)),
              _createElementVNode("div", {
                class: "w-4 h-4 mx-1 rounded-full",
                style: _normalizeStyle({ 'background-color': hexColor(trans) })
              }, null, 4)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})